"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.user_group.list': '用户组',
    'route.user_group.create': '添加用户组',
};
